interface Props {
  theme: "dark" | "light";
  onToggle: () => void;
}

export default function ThemeToggle({ theme, onToggle }: Props) {
  return (
    <button
      onClick={onToggle}
      title={`switch to ${theme === "dark" ? "light" : "dark"} mode`}
      className="px-2 py-1 rounded bg-mesh-panel hover:bg-mesh-panel/70 text-mesh-mute"
    >
      {theme === "dark" ? "☾" : "☀"}
    </button>
  );
}
